<template>
    <div>
        <div class="user-info-head" @click="editCropper()" style="text-align: center;line-height: 50px">
            <img height="50" v-if="fileId" v-bind:src="options.img" title="点击上传签名" class="img-circle img-lg"/>
            <a-button v-else >点击上传签名</a-button>
        </div>
        <a-modal :title="title" v-model:visible="open" width="800px" :visible="visible" centered :destroy-on-close="true" :mask-closable="false" :footer="null"
                 @close="closeDialog">
            <a-row>
                <a-col :xs="24" :md="12" :style="{height: '350px'}">
                    <vue-cropper
                        ref="cropper"
                        :img="options.img"
                        :info="true"
                        :autoCrop="options.autoCrop"
                        :autoCropWidth="options.autoCropWidth"
                        :autoCropHeight="options.autoCropHeight"
                        :fixedBox="options.fixedBox"
                        :outputType="options.outputType"
                        @realTime="realTime"
                        v-if="visible"
                    />
                </a-col>
                <a-col :xs="24" :md="12" :style="{height: '350px'}">
                    <div class="avatar-upload-preview">
                        <img :src="previews.url" :style="previews.img" />
                    </div>
                </a-col>
            </a-row>
            <br/>
            <a-row>
                <a-col :lg="2" :sm="3" :xs="3">
                    <a-upload action="#" :http-request="requestUpload" accept="image/*"
                              :before-upload="beforeUpload" :showUploadList="false">
                        <a-button size="small" type="primary">
                            选择图片
                        </a-button>
                    </a-upload>
                </a-col>
                <a-col :lg="{span: 1, offset: 2}" :sm="2" :xs="2">
                    <a-button size="small" @click="changeScale(1)">
                        <PlusOutlined/>
                    </a-button>
                </a-col>
                <a-col :lg="{span: 1, offset: 1}" :sm="2" :xs="2">
                    <a-button size="small" @click="changeScale(-1)">
                        <MinusOutlined/>
                    </a-button>
                </a-col>
                <a-col :lg="{span: 1, offset: 1}" :sm="2" :xs="2">
                    <a-button size="small" @click="rotateLeft()">
                        <RotateLeftOutlined/>
                    </a-button>
                </a-col>
                <a-col :lg="{span: 1, offset: 1}" :sm="2" :xs="2">
                    <a-button size="small" @click="rotateRight()">
                        <RotateRightOutlined/>
                    </a-button>
                </a-col>
                <a-col :lg="{span: 2, offset: 6}" :sm="2" :xs="2">
                    <a-button type="primary" size="small" @click="uploadImg()">提 交</a-button>
                </a-col>
            </a-row>
        </a-modal>
    </div>
</template>

<script>
import {VueCropper} from "vue-cropper";
import {file_service} from "@/api/adminService";
import {debounce} from '@/utils/util'
import {MinusOutlined, PlusOutlined, RotateLeftOutlined, RotateRightOutlined} from '@ant-design/icons-vue';
import axios from "axios";

export default {
    components: {VueCropper, PlusOutlined, MinusOutlined, RotateLeftOutlined, RotateRightOutlined},
    props:["fileId"],

    data() {
        return {
            // 是否显示弹出层
            open: false,
            // 是否显示cropper
            visible: true,
            // 弹出层标题
            title: "裁切签名",
            options: {
                img: '',  //裁剪图片的地址
                autoCrop: true,             // 是否默认生成截图框
                autoCropWidth: 140,         // 默认生成截图框宽度
                autoCropHeight: 50,        // 默认生成截图框高度
                fixedBox: true,             // 固定截图框大小 不允许改变
                outputType: "png",           // 默认生成截图为PNG格式
                filename: this.fileId?.split("|")[1]         // 文件名称
            },
            previews: {},
            resizeHandler: null
        };
    },
    watch:{
        "fileId":{
            immediate: true,
            handler(n) {
                if (n){
                    this.options.img = file_service.download+n
                }
            }
        },
        open(n){
            if (n){
                this.modalOpened()
            }
        }
    },
    methods: {
        // 编辑头像
        editCropper() {
            this.open = true;
        },
        // 打开弹出层结束时的回调
        modalOpened() {
            this.visible = true;
            if (!this.resizeHandler) {
              this.resizeHandler = debounce(() => {
                this.refresh()
              }, 100)
            }
            window.addEventListener("resize", this.resizeHandler)
        },
        // 刷新组件5
        refresh() {
            this.$refs.cropper.refresh();
        },
        // 覆盖默认的上传行为
        requestUpload() {
        },
        // 向左旋转
        rotateLeft() {
            this.$refs.cropper.rotateLeft();
        },
        // 向右旋转
        rotateRight() {
            this.$refs.cropper.rotateRight();
        },
        // 图片缩放
        changeScale(num) {
            num = num || 1;
            this.$refs.cropper.changeScale(num);
        },
        // 上传预处理
        beforeUpload(file) {
            if (file.type.indexOf("image/") == -1) {
                this.$message.warning("文件格式错误，请上传图片类型,如：JPG，PNG后缀的文件。");
            } else {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => {
                    this.options.img = reader.result;
                    this.options.filename = file.name;
                };
            }
        },
        // 上传图片
        uploadImg() {
            this.$refs.cropper.getCropBlob(data => {
                let formData = new FormData();
                // formData.append("avatarfile", data, this.options.filename);
                formData.append('file', data, this.options.filename);
                const request = axios.create({
                    // headers: headers,
                });
                return request
                    .post(file_service.upload, formData)
                    .then((response) => {
                        let fileId = response.data.data;
                        this.options.img = file_service.download+fileId
                        this.options.filename = fileId.split("|")[1]
                        this.$emit("finish", fileId);
                        return Promise.resolve(response.data);
                    })
                    .catch((error) => {
                        this.$message.warning("上传失败!");
                        return Promise.reject(error);
                    })
                    .finally(() => {
                        this.open = false;
                    });
            });
        },
        // 实时预览
        realTime(data) {
            this.previews = data;
        },
        // 关闭窗口
        closeDialog() {
            // this.options.img = file_service.download+this.fileId
            this.visible = false;
            window.removeEventListener("resize", this.resizeHandler)
        }
    }
};
</script>
<style scoped lang="less">
.user-info-head {
    position: relative;
    display: inline-block;
    height: 50px;
    width: 140px;
    cursor: pointer;
}

/*.user-info-head:hover:after {
    content: '+';
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    color: #eee;
    background: rgba(0, 0, 0, 0.5);
    font-size: 24px;
    font-style: normal;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    cursor: pointer;
    line-height: 50px;
}*/
.avatar-upload-preview {
    position: relative;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    width: 140px;
    height: 50px;
    -webkit-box-shadow: 0 0 4px #ccc;
    box-shadow: 0 0 4px #ccc;
    overflow: hidden;
}
</style>
